import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowDownIcon } from "@heroicons/react/24/outline";
import { GridPatternSVG, ConstructionShapeSVG } from "@/components/SVGElements";

const HeroSection = () => {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center overflow-hidden scroll-mt-20"
    >
      {/* Background Image - Indian Cityscape */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1769556353286-b7f50da70d0c?w=1920&q=80"
          alt="Modern Indian cityscape with skyscrapers"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 hero-overlay" />
      </div>

      {/* SVG Grid Pattern Overlay */}
      <div className="absolute inset-0 z-10 text-white">
        <GridPatternSVG />
      </div>
      
      {/* Decorative Construction Shape */}
      <div className="absolute right-0 bottom-0 w-64 h-64 z-10 opacity-20 hidden lg:block">
        <ConstructionShapeSVG color="#F97316" />
      </div>

      {/* Content */}
      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="max-w-3xl">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <span className="inline-block px-4 py-2 bg-orange-500/20 text-orange-400 text-sm font-semibold uppercase tracking-wider mb-6 font-manrope">
              Excellence in Engineering
            </span>
          </motion.div>
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="font-oswald text-4xl sm:text-5xl lg:text-7xl font-bold text-white leading-tight mb-6"
          >
            Perfection Delivered,
            <br />
            <span className="text-orange-500">On Time</span> Every Time
          </motion.h1>


          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="text-lg sm:text-xl text-slate-300 mb-10 font-manrope leading-relaxed max-w-2xl"
          >
            We Deliver Comprehensive PMC Solutions & Softwares For Construction Works
          </motion.p>

          <motion.div
  initial={{ opacity: 0, y: 30 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.6, delay: 0.5 }}
  className="flex flex-col sm:flex-row gap-6"
>
  <Link
    to="/services"
    className="bg-orange-500 hover:bg-orange-600 text-white text-lg px-12 py-5 rounded-lg font-semibold uppercase tracking-wider text-center transition-all min-w-[220px]"
    data-testid="hero-cta-primary"
  >
    Softwares
  </Link>

  <Link
    to="/services"
    className="px-12 py-5 border border-white text-white hover:bg-white/10 hover:border-white text-lg rounded-lg font-semibold uppercase tracking-wider text-center transition-all min-w-[220px]"
    data-testid="hero-cta-secondary"
  >
    PMC Services
  </Link>
</motion.div>


          {/* Stats */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="grid grid-cols-3 gap-8 mt-16 pt-8 border-t border-white/20"
          >
            <div>
              <p className="font-oswald text-3xl sm:text-4xl font-bold text-white">
                150<span className="text-orange-500">+</span>
              </p>
              <p className="text-slate-400 text-sm mt-1 font-manrope">
                Projects Completed
              </p>
            </div>
            <div>
              <p className="font-oswald text-3xl sm:text-4xl font-bold text-white">
                12<span className="text-orange-500">+</span>
              </p>
              <p className="text-slate-400 text-sm mt-1 font-manrope">
                Years Experience
              </p>
            </div>
            <div>
              <p className="font-oswald text-3xl sm:text-4xl font-bold text-white">
                50<span className="text-orange-500">+</span>
              </p>
              <p className="text-slate-400 text-sm mt-1 font-manrope">
                Expert Team
              </p>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 0.5 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center text-white/70"
        data-testid="scroll-indicator"
      >
        <span className="text-xs uppercase tracking-widest mb-2 font-manrope">
          Scroll
        </span>
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ duration: 1.5, repeat: Infinity }}
        >
          <ArrowDownIcon className="w-5 h-5" />
        </motion.div>
      </motion.div>
    </section>
  );
};

export default HeroSection;
